import { PAGE_DOWN, PAGE_UP, RESET_PAGINATION, SET_LAST_PAGE, UNSET_LAST_PAGE } from '../constants';

export default direction => dispatch => {
  if (direction === 'up') {
    dispatch({ type: PAGE_UP });
  } else if (direction === 'down') {
    dispatch({ type: PAGE_DOWN });
  }
};

export const resetPagination = () => ({ type: RESET_PAGINATION });

export const setLastPage = () => ({ type: SET_LAST_PAGE });

export const unsetLastPage = () => ({ type: UNSET_LAST_PAGE });
